export default __webpack_public_path__ + "static/media/attach_money.6e4c0db9.png";